import React from 'react'
import {Box} from '@mui/material'

const View = () => {
  return <Box>Health Page</Box>
}

export default View
